// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__Qy6G0","text__container":"styles_text__container__353Qj"};